import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';


export class Drawer extends Component {

  hideDrawer() {
    const drawer = document.getElementsByClassName('g-nav-drawer')[0];
    drawer.classList.remove('show');
  }

  render() {
    return (
      <div className="g-nav-drawer">
        <ul onClick={this.hideDrawer}>
          <li><NavLink to='/'>トップ</NavLink></li>
          <li><NavLink to='/history'>あゆみ</NavLink></li>
          <li><NavLink to='/director'>指導者紹介</NavLink></li>
          <li><NavLink to='/recruit'>メンバー募集</NavLink></li>
          <li><NavLink to='/info/1'>Info</NavLink></li>
          <li><NavLink to='/member/schedule'>メンバーページ</NavLink></li>
          <li><NavLink to='/vert-pin-plage'>Vert Pin Plage</NavLink></li>
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Drawer.jsx